import { defineComponent as _defineComponent } from 'vue'

import ISearchOptions from '../interfaces/ISearchOptions';

export default /*#__PURE__*/_defineComponent({
  props: {
  options: {
    type: Object as () => ISearchOptions,
    required: true,
  },
},
  emits: ['selectOption'],
  setup(__props, { expose }) {
  expose();




const __returned__ = { ISearchOptions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})